/* eslint-disable max-len, import/export, no-use-before-define */
import Vue from 'vue';
export default function mixins(...args) {
  return Vue.extend({
    mixins: args
  });
}
//# sourceMappingURL=mixins.js.map


// WEBPACK FOOTER //
// ./node_modules/vuetify/lib/util/mixins.js